import { render, staticRenderFns } from "./editPersonnelStatusAndTraining.vue?vue&type=template&id=55fdcad6&scoped=true&"
import script from "./editPersonnelStatusAndTraining.vue?vue&type=script&lang=js&"
export * from "./editPersonnelStatusAndTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdcad6",
  null
  
)

export default component.exports